import { Card } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../assets/css/accountanalysis.scss";
import { axiosInstance } from "../../../Axios";
import LongShortBalance from "../../../components/AccountAnalysis/LongShortBalance";
import LongShortComparison from "../../../components/AccountAnalysis/LongShortComparison";
import LongShortComparisonChart from "../../../components/AccountAnalysis/LongShortComparisonChart";
import LongShortTable from "../../../components/AccountAnalysis/LongShortTable";
import ResultByDaysChart from "../../../components/AccountAnalysis/ResultByDaysChart";
import ResultByTradeDuration from "../../../components/AccountAnalysis/ResultByTradeDuration";
import ResultsByOpenHour from "../../../components/AccountAnalysis/ResultsbyOpenHour";
import ResultsByOpenHourChart from "../../../components/AccountAnalysis/ResultsByOpenHourChart";
import ResultsByPosition from "../../../components/AccountAnalysis/ResultsbyPosition";
import ResultsByTrade from "../../../components/AccountAnalysis/ResultsbyTrade";
import LongShortWithTabs from "../../../components/Charts/LongShortWithTabs";
import Title from "../../../components/ReusableComponents/title";
import useMobile from "../../../hooks/useMobile";
import Loader from "../../../reusableComponents/Loader";
import MobileTabs from "../../../reusableComponents/MobileTabs/MobileTabs";
import { setLoading } from "../../../store/reducers/loader";
import ResultbyDays from "./../../../components/AccountAnalysis/ResultByDays";
import TradingdaysAnalysis from "./../../../components/AccountAnalysis/TradingdaysAnalysis";
// import General from "../General";
// import "../style.scss";
import General from "../../../pages/AccountAnalysis/General";
import { useParams } from "react-router";

const AccountAnalysisShare = () => {
    const ACCtoken = useSelector((state) => state.ACCtoken);
    const [AnalysisData, setAnalysisData] = useState(false);

    const [radio, setRadio] = useState("General");
    const [radioTab, setRadioTab] = useState("Long / Short Balance");
    const dispatch = useDispatch();

    const isMobile = useMobile();

    const [CurrentAcc, setCurrentAcc] = useState(false);

    const user_profile = useSelector((state) => state.user);
    const { current_platform } = useSelector((state) => state.user);
    const loader = useSelector((state) => state.loader.is_loading);
    const [open, setOpen] = useState(loader);
    useEffect(() => {
        setOpen(loader);
    }, [loader]);
    const { platform, accountId } = useParams();


    const getAccountAnalysis = async () => {
        dispatch(setLoading(true));
        if (!platform && !accountId) return;
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
            };
            config.headers["AUTHORIZATION"] = ACCtoken;

            const { data, status } = await axiosInstance.get(
                `v2/account-analysis/?login_id=${accountId?.replace("#","%23")}&platform=${platform}`,
                //   config
            );

            if (status === 200) {
                setAnalysisData(data);
                dispatch(setLoading(false));
                return true;
            }
        } catch (error) {
            dispatch(setLoading(false));

            console.error(error);
            return false;
        }
    };

    useEffect(() => {
        if (Object.keys(user_profile).length) {
            if (user_profile.current_account) {
                setCurrentAcc(user_profile.current_account);
            }
        }
    }, [user_profile]);

    useEffect(() => {
        getAccountAnalysis();
    }, [platform, accountId]);

    // useEffect(() => {
    //   getAccountAnalysis();
    // }, []);

    const handleChange = (e) => {
        let Option = e.currentTarget.getAttribute("value");
        let OptionName = e.currentTarget.textContent;
        console.log("Option:", Option);
        console.log("OptionName:", OptionName);
        setRadio(Option);
        setRadioTab(OptionName);
        setSelectedBtn(2);
        setTabShow(!TabShow);
    };

    const [selectedBtn, setSelectedBtn] = useState(1);

    const [value, setValue] = React.useState("1");
    const [Show, setShow] = React.useState(false);

    const handleChangeTab = (event, newValue) => {
        // debugger;
        event.preventDefault();
        setValue(newValue);
        setShow(false);
    };

    const [TabShow, setTabShow] = useState(false);

    const onClickTabs = () => {
        setTabShow(!TabShow);
    };

    const [profileActive, setProfileActive] = useState(1);
    const [mainTabination, setMainTabination] = useState(1);
    const [activeTab, setActiveTab] = useState(mainTabination);
    const [subActiveTab, setSubActiveTab] = useState(profileActive);

    useEffect(() => {
        setMainTabination(activeTab);
    }, [activeTab]);
    useEffect(() => {
        setProfileActive(subActiveTab);
    }, [subActiveTab]);

    const mainTabItems = [
        {
            name: "General Statistic",
            value: 1,
        },
        {
            name: "Account Analysis",
            value: 2,
        },
    ];
    const subTabItems = [
        {
            name: "Long / Short Balance",
            value: 1,
        },
        {
            name: "Results by days",
            value: 2,
        },
        {
            name: "Long / Short Comparison",
            value: 3,
        },
        {
            name: "Trading days Analysis",
            value: 4,
        },
        {
            name: "Results by Position size",
            value: 5,
        },
        {
            name: "Results by Trade Duration",
            value: 6,
        },
        {
            name: "Results by Open Hour",
            value: 7,
        },
    ];

    return (
        <div style={{ position: "relative" }} className="accountAnalysis_main">
            <Loader open={open} />

            {/* {isMobile && (
          <div className="MobileAccAnalysis">
            <Box className="account-analysis-ctn ContainerTab MainTab ">
              <TabContext value={value}>
                <Box
                  className=""
                  sx={{ borderBottom: 1, borderColor: "divider" }}
                >
                  <TabList
                    onClick={() => setShow(false)}
                    onChange={handleChangeTab}
                    aria-label="lab API tabs example"
                  >
                    <Tab
                      className="ContainertabName"
                      label="General Statistics"
                      value="1"
                    />
                    <Tab
                      className="ContainertabName"
                      label="Account Analysis"
                      value="2"
                    />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <General data={AnalysisData && AnalysisData} />
                </TabPanel>
                <TabPanel value="2">
                  <Analysis
                    TabShow={TabShow}
                    handleChange={handleChange}
                    onClickTabs={onClickTabs}
                    radioTab={radioTab}
                    radio={radio}
                    AnalysisData={AnalysisData}
                  />
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        )} */}

            {/* {!isMobile && ( */}
            <div container className="account-analysis-ctn">
                <div className="newTabination">
                    <div
                        onClick={() => {
                            setMainTabination(1);
                        }}
                        className={
                            "newTabination-item " + (mainTabination === 1 && " active ")
                        }
                    >
                        <div className="svg-con">
                            <svg
                                width="16"
                                height="14"
                                viewBox="0 0 16 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="general-statistics-icon"
                            >
                                <path
                                    d="M1.5 0.75V12.5H15.25C15.4489 12.5 15.6397 12.579 15.7803 12.7197C15.921 12.8603 16 13.0511 16 13.25C16 13.4489 15.921 13.6397 15.7803 13.7803C15.6397 13.921 15.4489 14 15.25 14H0.75C0.551088 14 0.360322 13.921 0.21967 13.7803C0.0790176 13.6397 0 13.4489 0 13.25L0 0.75C0 0.551088 0.0790176 0.360322 0.21967 0.21967C0.360322 0.0790177 0.551088 0 0.75 0C0.948912 0 1.13968 0.0790177 1.28033 0.21967C1.42098 0.360322 1.5 0.551088 1.5 0.75ZM15.78 3.28L10.53 8.53C10.3894 8.67045 10.1988 8.74934 10 8.74934C9.80125 8.74934 9.61063 8.67045 9.47 8.53L7 6.06L4.28 8.78C4.13774 8.91241 3.94969 8.98451 3.75537 8.98116C3.56105 8.9778 3.3756 8.89924 3.238 8.762C3.10076 8.6244 3.0222 8.43895 3.01884 8.24463C3.01549 8.05031 3.08759 7.86226 3.22 7.72L6.47 4.47C6.61063 4.32955 6.80125 4.25066 7 4.25066C7.19875 4.25066 7.38937 4.32955 7.53 4.47L10 6.94L14.72 2.22C14.8623 2.08759 15.0503 2.01549 15.2446 2.01884C15.4389 2.0222 15.6244 2.10076 15.762 2.238C15.8992 2.3756 15.9778 2.56105 15.9812 2.75537C15.9845 2.94969 15.9124 3.13774 15.78 3.28Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                        General Statistic
                    </div>

                    <div
                        onClick={() => {
                            setMainTabination(2);
                        }}
                        className={
                            "newTabination-item " + (mainTabination === 2 && " active ")
                        }
                    >
                        <div className="svg-con">
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0.75 10C0.75 5.46703 3.94662 1.68093 8.25 0.86453V19.1355C3.94662 18.3191 0.75 14.533 0.75 10ZM19.1318 8.25H11.75V0.868232C15.5173 1.59213 18.4079 4.48268 19.1318 8.25ZM19.1306 11.75C18.3985 15.5073 15.4476 18.3986 11.75 19.1285V11.75H19.1306Z"
                                    stroke="#F6F6F6"
                                    stroke-width="1.5"
                                />
                            </svg>
                        </div>
                        Account Analysis
                    </div>
                </div>

                <div className="mobileTabOption">
                    <MobileTabs
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        tabItems={mainTabItems}
                    />
                </div>

                {mainTabination === 2 && (
                    <div className="account-analysis-options">
                        <div
                            className={
                                "profileTabination accountANALYSIS " +
                                (mainTabination === 1 && " disable")
                            }
                        >
                            <div
                                onClick={() => setProfileActive(1)}
                                className={
                                    "profileTabination-item " +
                                    (profileActive === 1 && " active ")
                                }
                            >
                                {" "}
                                <div className="svgCon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M5 12.8571L6.46033 9.88009C7.19794 8.3764 9.36584 8.44984 10 10C10.6342 11.5502 12.8021 11.6236 13.5397 10.1199L15 7.14286M10 19C6.25027 19 4.3754 19 3.06107 18.0451C2.6366 17.7367 2.26331 17.3634 1.95491 16.9389C1 15.6246 1 13.7497 1 10C1 6.25027 1 4.3754 1.95491 3.06107C2.26331 2.6366 2.6366 2.26331 3.06107 1.95491C4.3754 1 6.25027 1 10 1C13.7497 1 15.6246 1 16.9389 1.95491C17.3634 2.26331 17.7367 2.6366 18.0451 3.06107C19 4.3754 19 6.25027 19 10C19 13.7497 19 15.6246 18.0451 16.9389C17.7367 17.3634 17.3634 17.7367 16.9389 18.0451C15.6246 19 13.7497 19 10 19Z"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                        />
                                    </svg>
                                </div>{" "}
                                Long / Short Balance
                            </div>
                            <div
                                onClick={() => setProfileActive(2)}
                                className={
                                    "profileTabination-item " +
                                    (profileActive === 2 && " active ")
                                }
                            >
                                {" "}
                                <div className="svgCon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="21"
                                        viewBox="0 0 16 21"
                                        fill="none"
                                    >
                                        <path
                                            d="M1 8C1 6.13872 1 5.20808 1.24472 4.45492C1.73931 2.93273 2.93273 1.73931 4.45492 1.24472C5.20808 1 6.13872 1 8 1C9.86128 1 10.7919 1 11.5451 1.24472C13.0673 1.73931 14.2607 2.93273 14.7553 4.45492C15 5.20808 15 6.13872 15 8V15.3874C15 17.3045 15 18.2631 14.658 18.77C14.2403 19.3893 13.5122 19.7242 12.7701 19.6383C12.1627 19.568 11.4349 18.9442 9.97931 17.6965C9.33858 17.1474 9.01821 16.8728 8.66631 16.7484C8.23517 16.5961 7.76483 16.5961 7.33369 16.7484C6.98179 16.8728 6.66142 17.1474 6.02069 17.6965C4.5651 18.9442 3.8373 19.568 3.22986 19.6383C2.48778 19.7242 1.75971 19.3893 1.34196 18.77C1 18.2631 1 17.3045 1 15.3874V8Z"
                                            stroke="#F6F6F6"
                                            stroke-width="1.5"
                                        />
                                    </svg>
                                </div>{" "}
                                Results by days
                            </div>
                            <div
                                onClick={() => setProfileActive(3)}
                                className={
                                    "profileTabination-item " +
                                    (profileActive === 3 && " active ")
                                }
                            >
                                {" "}
                                <div className="svgCon">
                                    {/* <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="keySvg"
                      >
                        <g clip-path="url(#clip0_266_6289)">
                          <path
                            d="M8.45492 18.7553L8.68668 18.042L8.45492 18.7553ZM5.24472 15.5451L5.95801 15.3133L5.24472 15.5451ZM18.7553 15.5451L18.042 15.3133L18.7553 15.5451ZM15.5451 18.7553L15.3133 18.042L15.5451 18.7553ZM15.5451 5.24472L15.3133 5.95801L15.5451 5.24472ZM18.7553 8.45492L18.042 8.68668L18.7553 8.45492ZM8.45492 5.24472L8.68668 5.95801L8.45492 5.24472ZM5.24472 8.45492L5.95801 8.68668L5.24472 8.45492ZM1 11.25C0.585786 11.25 0.25 11.5858 0.25 12C0.25 12.4142 0.585786 12.75 1 12.75V11.25ZM12.75 1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1H12.75ZM11.25 23C11.25 23.4142 11.5858 23.75 12 23.75C12.4142 23.75 12.75 23.4142 12.75 23H11.25ZM23 12.75C23.4142 12.75 23.75 12.4142 23.75 12C23.75 11.5858 23.4142 11.25 23 11.25V12.75ZM12 18.25C10.0803 18.25 9.29839 18.2407 8.68668 18.042L8.22315 19.4686C9.11777 19.7593 10.1971 19.75 12 19.75V18.25ZM4.25 12C4.25 13.8029 4.24075 14.8822 4.53143 15.7768L5.95801 15.3133C5.75925 14.7016 5.75 13.9197 5.75 12H4.25ZM8.68668 18.042C7.39282 17.6216 6.37841 16.6072 5.95801 15.3133L4.53143 15.7768C5.1002 17.5274 6.47263 18.8998 8.22315 19.4686L8.68668 18.042ZM18.25 12C18.25 13.9197 18.2407 14.7016 18.042 15.3133L19.4686 15.7768C19.7593 14.8822 19.75 13.8029 19.75 12H18.25ZM12 19.75C13.8029 19.75 14.8822 19.7593 15.7768 19.4686L15.3133 18.042C14.7016 18.2407 13.9197 18.25 12 18.25V19.75ZM18.042 15.3133C17.6216 16.6072 16.6072 17.6216 15.3133 18.042L15.7768 19.4686C17.5274 18.8998 18.8998 17.5274 19.4686 15.7768L18.042 15.3133ZM12 5.75C13.9197 5.75 14.7016 5.75925 15.3133 5.95801L15.7768 4.53143C14.8822 4.24075 13.8029 4.25 12 4.25V5.75ZM19.75 12C19.75 10.1971 19.7593 9.11777 19.4686 8.22315L18.042 8.68668C18.2407 9.29839 18.25 10.0803 18.25 12H19.75ZM15.3133 5.95801C16.6072 6.37841 17.6216 7.39282 18.042 8.68668L19.4686 8.22315C18.8998 6.47263 17.5274 5.1002 15.7768 4.53143L15.3133 5.95801ZM12 4.25C10.1971 4.25 9.11777 4.24075 8.22315 4.53143L8.68668 5.95801C9.29839 5.75925 10.0803 5.75 12 5.75V4.25ZM5.75 12C5.75 10.0803 5.75925 9.29839 5.95801 8.68668L4.53143 8.22315C4.24075 9.11777 4.25 10.1971 4.25 12H5.75ZM8.22315 4.53143C6.47263 5.1002 5.1002 6.47263 4.53143 8.22315L5.95801 8.68668C6.37841 7.39282 7.39282 6.37841 8.68668 5.95801L8.22315 4.53143ZM5 11.25H1V12.75H5V11.25ZM12.75 5V1H11.25V5H12.75ZM12.75 23V19H11.25V23H12.75ZM23 11.25H19V12.75H23V11.25Z"
                            fill="#8F8F8F"
                          />
                          <path
                            d="M10.25 12C10.25 12.9665 11.0335 13.75 12 13.75C12.9665 13.75 13.75 12.9665 13.75 12C13.75 11.0335 12.9665 10.25 12 10.25C11.0335 10.25 10.25 11.0335 10.25 12Z"
                            stroke="#8F8F8F"
                            stroke-width="1.5"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_266_6289">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg> */}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M8.45492 18.7553L8.68668 18.042L8.45492 18.7553ZM5.24472 15.5451L5.95801 15.3133L5.24472 15.5451ZM18.7553 15.5451L18.042 15.3133L18.7553 15.5451ZM15.5451 18.7553L15.3133 18.042L15.5451 18.7553ZM15.5451 5.24472L15.3133 5.95801L15.5451 5.24472ZM18.7553 8.45492L18.042 8.68668L18.7553 8.45492ZM8.45492 5.24472L8.68668 5.95801L8.45492 5.24472ZM5.24472 8.45492L5.95801 8.68668L5.24472 8.45492ZM1 11.25C0.585786 11.25 0.25 11.5858 0.25 12C0.25 12.4142 0.585786 12.75 1 12.75V11.25ZM12.75 1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1H12.75ZM11.25 23C11.25 23.4142 11.5858 23.75 12 23.75C12.4142 23.75 12.75 23.4142 12.75 23H11.25ZM23 12.75C23.4142 12.75 23.75 12.4142 23.75 12C23.75 11.5858 23.4142 11.25 23 11.25V12.75ZM12 18.25C10.0803 18.25 9.29839 18.2407 8.68668 18.042L8.22315 19.4686C9.11777 19.7593 10.1971 19.75 12 19.75V18.25ZM4.25 12C4.25 13.8029 4.24075 14.8822 4.53143 15.7768L5.95801 15.3133C5.75925 14.7016 5.75 13.9197 5.75 12H4.25ZM8.68668 18.042C7.39282 17.6216 6.37841 16.6072 5.95801 15.3133L4.53143 15.7768C5.1002 17.5274 6.47263 18.8998 8.22315 19.4686L8.68668 18.042ZM18.25 12C18.25 13.9197 18.2407 14.7016 18.042 15.3133L19.4686 15.7768C19.7593 14.8822 19.75 13.8029 19.75 12H18.25ZM12 19.75C13.8029 19.75 14.8822 19.7593 15.7768 19.4686L15.3133 18.042C14.7016 18.2407 13.9197 18.25 12 18.25V19.75ZM18.042 15.3133C17.6216 16.6072 16.6072 17.6216 15.3133 18.042L15.7768 19.4686C17.5274 18.8998 18.8998 17.5274 19.4686 15.7768L18.042 15.3133ZM12 5.75C13.9197 5.75 14.7016 5.75925 15.3133 5.95801L15.7768 4.53143C14.8822 4.24075 13.8029 4.25 12 4.25V5.75ZM19.75 12C19.75 10.1971 19.7593 9.11777 19.4686 8.22315L18.042 8.68668C18.2407 9.29839 18.25 10.0803 18.25 12H19.75ZM15.3133 5.95801C16.6072 6.37841 17.6216 7.39282 18.042 8.68668L19.4686 8.22315C18.8998 6.47263 17.5274 5.1002 15.7768 4.53143L15.3133 5.95801ZM12 4.25C10.1971 4.25 9.11777 4.24075 8.22315 4.53143L8.68668 5.95801C9.29839 5.75925 10.0803 5.75 12 5.75V4.25ZM5.75 12C5.75 10.0803 5.75925 9.29839 5.95801 8.68668L4.53143 8.22315C4.24075 9.11777 4.25 10.1971 4.25 12H5.75ZM8.22315 4.53143C6.47263 5.1002 5.1002 6.47263 4.53143 8.22315L5.95801 8.68668C6.37841 7.39282 7.39282 6.37841 8.68668 5.95801L8.22315 4.53143ZM5 11.25H1V12.75H5V11.25ZM12.75 5V1H11.25V5H12.75ZM12.75 23V19H11.25V23H12.75ZM23 11.25H19V12.75H23V11.25Z"
                                            fill="#F6F6F6"
                                        />
                                        <path
                                            d="M10.25 12C10.25 12.9665 11.0335 13.75 12 13.75C12.9665 13.75 13.75 12.9665 13.75 12C13.75 11.0335 12.9665 10.25 12 10.25C11.0335 10.25 10.25 11.0335 10.25 12Z"
                                            stroke="#F6F6F6"
                                            stroke-width="1.5"
                                        />
                                    </svg>
                                </div>{" "}
                                Long / Short Comparison
                            </div>
                            <div
                                onClick={() => setProfileActive(4)}
                                className={
                                    "profileTabination-item " +
                                    (profileActive === 4 && " active ")
                                }
                            >
                                {" "}
                                <div className="svgCon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <g clip-path="url(#clip0_4258_6148)">
                                            <path
                                                d="M9.23485 2.89914C9.23485 2.68689 9.14491 2.48457 8.98734 2.34236C8.82977 2.20015 8.61932 2.13137 8.40817 2.15307C4.15663 2.59002 0.840909 6.18126 0.840909 10.5479C0.840909 15.2088 4.61936 18.9873 9.2803 18.9873C13.6469 18.9873 17.2382 15.6716 17.6751 11.42C17.6968 11.2089 17.628 10.9984 17.4858 10.8409C17.3436 10.6833 17.1413 10.5933 16.9291 10.5933H9.2803C9.2552 10.5933 9.23485 10.573 9.23485 10.5479V2.89914ZM9.32576 9.75244C9.32576 10.1666 9.66154 10.5024 10.0758 10.5024H17.7652C17.7903 10.5024 17.8106 10.5228 17.8106 10.5479C17.8106 15.259 13.9915 19.0782 9.2803 19.0782C4.56915 19.0782 0.75 15.259 0.75 10.5479C0.75 5.83673 4.56915 2.01759 9.2803 2.01759C9.30541 2.01759 9.32576 2.03794 9.32576 2.06304V9.75244ZM13.1648 0.986981C12.9417 0.934302 12.7068 0.986539 12.527 1.12879C12.3473 1.27104 12.2424 1.48768 12.2424 1.71691V6.83577C12.2424 7.24998 12.5782 7.58577 12.9924 7.58577H18.1113C18.3405 7.58577 18.5572 7.48094 18.6994 7.30119C18.8417 7.12144 18.8939 6.8865 18.8412 6.66341C18.1788 3.85805 15.9701 1.64941 13.1648 0.986981ZM12.3674 0.751472C15.8663 1.1869 18.6413 3.96185 19.0767 7.4608C19.083 7.51099 19.069 7.55457 19.0296 7.59551C18.9863 7.64052 18.9146 7.67668 18.8258 7.67668H12.1515V1.00244C12.1515 0.913632 12.1877 0.841894 12.2327 0.7986C12.2736 0.759229 12.3172 0.745225 12.3674 0.751472Z"
                                                fill="#F6F6F6"
                                                stroke="#F6F6F6"
                                                stroke-width="1.5"
                                                stroke-linejoin="round"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_4258_6148">
                                                <rect width="20" height="20" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>{" "}
                                Trading days Analysis
                            </div>
                            <div
                                onClick={() => setProfileActive(5)}
                                className={
                                    "profileTabination-item " +
                                    (profileActive === 5 && " active ")
                                }
                            >
                                {" "}
                                <div className="svgCon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="22"
                                        viewBox="0 0 20 22"
                                        fill="none"
                                    >
                                        <path
                                            d="M3.06107 20.0451L3.50191 19.4383L3.06107 20.0451ZM1.95491 18.9389L2.56168 18.4981L1.95491 18.9389ZM18.0451 18.9389L17.4383 18.4981L18.0451 18.9389ZM16.9389 20.0451L16.4981 19.4383L16.9389 20.0451ZM16.9389 1.95491L17.3798 1.34815L16.9389 1.95491ZM18.0451 3.06107L17.4383 3.50191L18.0451 3.06107ZM3.06107 1.95491L3.50191 2.56168L3.06107 1.95491ZM1.95491 3.06107L2.56168 3.50191L1.95491 3.06107ZM11.1461 5.59531L11.2635 6.33608L11.1461 5.59531ZM9.5818 5.59531L9.46447 6.33608L9.5818 5.59531ZM6 16.25C5.58579 16.25 5.25 16.5858 5.25 17C5.25 17.4142 5.58579 17.75 6 17.75V16.25ZM14 17.75C14.4142 17.75 14.75 17.4142 14.75 17C14.75 16.5858 14.4142 16.25 14 16.25V17.75ZM6 12.25C5.58579 12.25 5.25 12.5858 5.25 13C5.25 13.4142 5.58579 13.75 6 13.75V12.25ZM14 13.75C14.4142 13.75 14.75 13.4142 14.75 13C14.75 12.5858 14.4142 12.25 14 12.25V13.75ZM6 8.25C5.58579 8.25 5.25 8.58579 5.25 9C5.25 9.41421 5.58579 9.75 6 9.75V8.25ZM9 9.75C9.41421 9.75 9.75 9.41421 9.75 9C9.75 8.58579 9.41421 8.25 9 8.25V9.75ZM18.25 10V12H19.75V10H18.25ZM1.75 12V10H0.25V12H1.75ZM10 20.25C8.10843 20.25 6.74999 20.249 5.69804 20.135C4.66013 20.0225 4.00992 19.8074 3.50191 19.4383L2.62023 20.6518C3.42656 21.2377 4.37094 21.5 5.53648 21.6263C6.68798 21.751 8.14184 21.75 10 21.75V20.25ZM0.25 12C0.25 13.8582 0.248971 15.312 0.373728 16.4635C0.500006 17.6291 0.762324 18.5734 1.34815 19.3798L2.56168 18.4981C2.19259 17.9901 1.97745 17.3399 1.865 16.302C1.75103 15.25 1.75 13.8916 1.75 12H0.25ZM3.50191 19.4383C3.14111 19.1762 2.82382 18.8589 2.56168 18.4981L1.34815 19.3798C1.70281 19.8679 2.13209 20.2972 2.62023 20.6518L3.50191 19.4383ZM18.25 12C18.25 13.8916 18.249 15.25 18.135 16.302C18.0225 17.3399 17.8074 17.9901 17.4383 18.4981L18.6518 19.3798C19.2377 18.5734 19.5 17.6291 19.6263 16.4635C19.751 15.312 19.75 13.8582 19.75 12H18.25ZM10 21.75C11.8582 21.75 13.312 21.751 14.4635 21.6263C15.6291 21.5 16.5734 21.2377 17.3798 20.6518L16.4981 19.4383C15.9901 19.8074 15.3399 20.0225 14.302 20.135C13.25 20.249 11.8916 20.25 10 20.25V21.75ZM17.4383 18.4981C17.1762 18.8589 16.8589 19.1762 16.4981 19.4383L17.3798 20.6518C17.8679 20.2972 18.2972 19.8679 18.6518 19.3798L17.4383 18.4981ZM19.75 10C19.75 8.14184 19.751 6.68798 19.6263 5.53648C19.5 4.37094 19.2377 3.42656 18.6518 2.62023L17.4383 3.50191C17.8074 4.00992 18.0225 4.66013 18.135 5.69804C18.249 6.74999 18.25 8.10843 18.25 10H19.75ZM16.4981 2.56168C16.8589 2.82382 17.1762 3.14111 17.4383 3.50191L18.6518 2.62023C18.2972 2.13209 17.8679 1.70281 17.3798 1.34815L16.4981 2.56168ZM1.75 10C1.75 8.10843 1.75103 6.74999 1.865 5.69804C1.97745 4.66013 2.19259 4.00992 2.56168 3.50191L1.34815 2.62023C0.762324 3.42656 0.500006 4.37094 0.373728 5.53648C0.248971 6.68798 0.25 8.14184 0.25 10H1.75ZM2.62023 1.34815C2.13209 1.70281 1.70281 2.13209 1.34815 2.62023L2.56168 3.50191C2.82382 3.14111 3.14111 2.82382 3.50191 2.56168L2.62023 1.34815ZM11.0288 4.85454C10.5883 4.92431 10.1396 4.92431 9.69912 4.85454L9.46447 6.33608C10.0604 6.43047 10.6675 6.43047 11.2635 6.33608L11.0288 4.85454ZM15.9103 1.12083C14.6701 2.36015 13.7663 3.25006 12.9856 3.8649C12.2161 4.47095 11.6262 4.75993 11.0288 4.85454L11.2635 6.33608C12.2116 6.1859 13.0379 5.73301 13.9137 5.04333C14.7783 4.36245 15.7488 3.40277 16.9706 2.18187L15.9103 1.12083ZM10 1.75C11.6617 1.75 12.9149 1.75053 13.9149 1.82911C14.9124 1.9075 15.5844 2.05963 16.1028 2.32103L16.7782 0.981678C16.0049 0.591725 15.107 0.418172 14.0324 0.333724C12.9603 0.249471 11.6391 0.25 10 0.25V1.75ZM16.1028 2.32103C16.2431 2.3918 16.374 2.4715 16.4981 2.56168L17.3798 1.34815C17.1892 1.20967 16.9892 1.08809 16.7782 0.981678L16.1028 2.32103ZM3.5419 1.96653C4.83246 3.25703 5.84545 4.26842 6.73841 4.98311C7.64243 5.70666 8.48904 6.18158 9.46447 6.33608L9.69912 4.85454C9.08459 4.75721 8.47813 4.45425 7.67572 3.81202C6.86225 3.16095 5.91543 2.21868 4.60254 0.905846L3.5419 1.96653ZM10 0.25C8.56371 0.25 7.37369 0.249733 6.38484 0.305723C5.39671 0.361672 4.55633 0.47576 3.82759 0.727205L4.31685 2.14517C4.85227 1.96043 5.53187 1.85642 6.46964 1.80332C7.40668 1.75027 8.54848 1.75 10 1.75V0.25ZM3.82759 0.727205C3.38699 0.879231 2.98789 1.08103 2.62023 1.34815L3.50191 2.56168C3.73848 2.3898 4.00284 2.25352 4.31685 2.14517L3.82759 0.727205ZM6 17.75H14V16.25H6V17.75ZM6 13.75H14V12.25H6V13.75ZM6 9.75H9V8.25H6V9.75Z"
                                            fill="#F6F6F6"
                                        />
                                    </svg>
                                </div>{" "}
                                Results by Position size
                            </div>
                            <div
                                onClick={() => setProfileActive(6)}
                                className={
                                    "profileTabination-item " +
                                    (profileActive === 6 && " active ")
                                }
                            >
                                {" "}
                                <div className="svgCon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="23"
                                        viewBox="0 0 22 23"
                                        fill="none"
                                    >
                                        <path
                                            d="M11.75 8C11.75 7.58579 11.4142 7.25 11 7.25C10.5858 7.25 10.25 7.58579 10.25 8H11.75ZM13.2232 15.1495C13.5819 15.3566 14.0406 15.2337 14.2477 14.875C14.4548 14.5163 14.3319 14.0576 13.9731 13.8505L13.2232 15.1495ZM1.53148 2.66435C1.20803 2.92311 1.15559 3.39507 1.41435 3.71852C1.67311 4.04197 2.14507 4.09441 2.46852 3.83565L1.53148 2.66435ZM4.96852 1.83565C5.29197 1.57689 5.34441 1.10493 5.08565 0.781479C4.82689 0.458032 4.35493 0.405591 4.03148 0.664348L4.96852 1.83565ZM19.5315 3.83565C19.8549 4.09441 20.3269 4.04197 20.5857 3.71852C20.8444 3.39507 20.792 2.92311 20.4685 2.66435L19.5315 3.83565ZM17.9685 0.664348C17.6451 0.405591 17.1731 0.458032 16.9143 0.781479C16.6556 1.10493 16.708 1.57689 17.0315 1.83565L17.9685 0.664348ZM11 10.6906H10.25H11ZM13 14.1547L13.375 13.5052L13 14.1547ZM11.268 12.8453L11.9175 12.4703L11.268 12.8453ZM10.25 8L10.25 10.6906L11.75 10.6906L11.75 8H10.25ZM13.9731 13.8505L13.375 13.5052L12.625 14.8042L13.2232 15.1495L13.9731 13.8505ZM20.25 12C20.25 17.1086 16.1086 21.25 11 21.25V22.75C16.9371 22.75 21.75 17.9371 21.75 12H20.25ZM11 21.25C5.89137 21.25 1.75 17.1086 1.75 12H0.25C0.25 17.9371 5.06294 22.75 11 22.75V21.25ZM1.75 12C1.75 6.89137 5.89137 2.75 11 2.75V1.25C5.06294 1.25 0.25 6.06294 0.25 12H1.75ZM11 2.75C16.1086 2.75 20.25 6.89137 20.25 12H21.75C21.75 6.06294 16.9371 1.25 11 1.25V2.75ZM2.46852 3.83565L4.96852 1.83565L4.03148 0.664348L1.53148 2.66435L2.46852 3.83565ZM20.4685 2.66435L17.9685 0.664348L17.0315 1.83565L19.5315 3.83565L20.4685 2.66435ZM10.25 10.6906C10.25 11.2395 10.2492 11.7051 10.2871 12.0901C10.3267 12.4915 10.4125 12.8636 10.6184 13.2203L11.9175 12.4703C11.8555 12.3629 11.8073 12.2211 11.7799 11.943C11.7508 11.6484 11.75 11.2687 11.75 10.6906L10.25 10.6906ZM13.375 13.5052C12.8744 13.2161 12.5459 13.0255 12.3054 12.8531C12.0782 12.6903 11.9795 12.5777 11.9175 12.4703L10.6184 13.2203C10.8244 13.577 11.1037 13.8373 11.4315 14.0723C11.746 14.2977 12.1496 14.5297 12.625 14.8042L13.375 13.5052Z"
                                            fill="#F6F6F6"
                                        />
                                    </svg>
                                </div>{" "}
                                Results by Trade Duration
                            </div>
                            <div
                                onClick={() => setProfileActive(7)}
                                className={
                                    "profileTabination-item " +
                                    (profileActive === 7 && " active ")
                                }
                            >
                                {" "}
                                <div className="svgCon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="22"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                    >
                                        <path
                                            d="M11.75 7.25C11.75 6.83579 11.4142 6.5 11 6.5C10.5858 6.5 10.25 6.83579 10.25 7.25H11.75ZM8.4543 13.8568C8.17015 14.1582 8.18412 14.6329 8.4855 14.917C8.78689 15.2012 9.26156 15.1872 9.5457 14.8858L8.4543 13.8568ZM10.4552 12.8278L9.90951 12.3133L10.4552 12.8278ZM10.25 7.25V11.4558H11.75V7.25H10.25ZM9.5457 14.8858L11.0009 13.3423L9.90951 12.3133L8.4543 13.8568L9.5457 14.8858ZM20.25 11.25C20.25 16.3586 16.1086 20.5 11 20.5V22C16.9371 22 21.75 17.1871 21.75 11.25H20.25ZM11 20.5C5.89137 20.5 1.75 16.3586 1.75 11.25H0.25C0.25 17.1871 5.06294 22 11 22V20.5ZM1.75 11.25C1.75 6.14137 5.89137 2 11 2V0.5C5.06294 0.5 0.25 5.31294 0.25 11.25H1.75ZM11 2C16.1086 2 20.25 6.14137 20.25 11.25H21.75C21.75 5.31294 16.9371 0.5 11 0.5V2ZM10.25 11.4558C10.25 11.7746 10.1282 12.0814 9.90951 12.3133L11.0009 13.3423C11.482 12.832 11.75 12.1572 11.75 11.4558H10.25Z"
                                            fill="#F6F6F6"
                                        />
                                    </svg>
                                </div>{" "}
                                Results by Open Hour
                            </div>
                        </div>

                        <div className="mobileTabOption">
                            <MobileTabs
                                activeTab={subActiveTab}
                                setActiveTab={setSubActiveTab}
                                tabItems={subTabItems}
                            />
                        </div>

                        <div className="RightSection">
                            {profileActive === 1 && mainTabination === 2 && (
                                <>
                                    <Card className="card-csc">
                                        <Title six>Long/Short Comparison</Title>
                                        <LongShortTable
                                            data={AnalysisData && AnalysisData?.long_short_comp}
                                            dataTwo={AnalysisData?.close_open}
                                        />
                                    </Card>
                                    <Card className="card-csc">
                                        <Title six>Long balance</Title>

                                        {/* <LongShortChart data={AnalysisData} /> */}
                                        <LongShortWithTabs data={AnalysisData?.long_short_comp} />
                                    </Card>
                                </>
                            )}

                            {profileActive === 2 && mainTabination === 2 && (
                                <>
                                    <div className="result_by_close_main">
                                        <Title six>Results by close</Title>
                                        <div className="result_by_close_inner">
                                            <Card className="card-csc">
                                                <ResultByDaysChart
                                                    data={AnalysisData && AnalysisData?.day_wise_data}
                                                />
                                                {/* <LongShortChart
                            data={AnalysisData && AnalysisData.day_wise_data}
                          /> */}
                                            </Card>
                                            {/* <Card className="card-csc">
                          <LongShortChart
                            data={AnalysisData && AnalysisData.day_wise_data}
                          />
                        </Card> */}
                                        </div>
                                    </div>
                                </>
                            )}

                            {profileActive === 3 && mainTabination === 2 && (
                                <>
                                    <div className="result_by_close_main">
                                        <Title six>Results by open</Title>
                                        <div className="result_by_close_inner">
                                            <Card className="card-csc">
                                                <LongShortComparisonChart
                                                    data={
                                                        AnalysisData && AnalysisData?.result_by_instruments
                                                    }
                                                />
                                                {/* <LongShortChart
                            data={
                              AnalysisData && AnalysisData?.result_by_instruments
                            }
                          /> */}
                                            </Card>
                                        </div>
                                    </div>
                                </>
                            )}

                            {profileActive === 4 && mainTabination === 2 && (
                                <>
                                    <Card className="card-csc">
                                        <Title six>Trading days analysis</Title>
                                        <TradingdaysAnalysis
                                            data={AnalysisData && AnalysisData?.trading_days_analysis}
                                        />
                                    </Card>
                                    <Card className="card-csc">
                                        <Title six>Long Balance</Title>
                                        {/* <LongShortChart data={AnalysisData} /> */}
                                        <LongShortWithTabs
                                            data={AnalysisData && AnalysisData.trading_days_analysis}
                                        />
                                    </Card>
                                </>
                            )}

                            {profileActive === 5 && mainTabination === 2 && (
                                <>
                                    <div className="result_by_close_main">
                                        <Title six>Average profit / Average loss</Title>
                                        <div className="result_by_close_inner">
                                            <Card className="card-csc">
                                                <ResultsByPosition
                                                    data={AnalysisData && AnalysisData?.results_by_lots}
                                                />
                                                {/* <LongShortChart
                            data={AnalysisData && AnalysisData.results_by_lots}
                          /> */}
                                            </Card>
                                        </div>
                                    </div>
                                </>
                            )}

                            {profileActive === 6 && mainTabination === 2 && (
                                <>
                                    <div className="result_by_close_main">
                                        <Title six>Average profit / Average loss</Title>
                                        <div className="result_by_close_inner">
                                            <Card className="card-csc">
                                                <ResultByTradeDuration
                                                    data={
                                                        AnalysisData &&
                                                        AnalysisData.result_by_trade_duration?.chart
                                                    }
                                                />
                                                {/* <LongShortChart
                            data={AnalysisData && AnalysisData.day_wise_data}
                          /> */}
                                            </Card>
                                        </div>
                                    </div>
                                </>
                            )}
                            {profileActive === 7 && mainTabination === 2 && (
                                <>
                                    <div className="result_by_close_main">
                                        <Title six>Average profit / Average loss</Title>
                                        <div className="result_by_close_inner">
                                            <Card className="card-csc">
                                                <ResultsByOpenHourChart
                                                    data={
                                                        AnalysisData &&
                                                        AnalysisData?.result_by_open_hour?.chart_data
                                                    }
                                                />
                                                {/* <LongShortChart
                            data={AnalysisData && AnalysisData.day_wise_data}
                          /> */}
                                            </Card>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                )}

                <div className="long-short-competition">
                    {mainTabination === 1 && (
                        <General data={AnalysisData && AnalysisData} />
                    )}

                    {profileActive === 1 && mainTabination === 2 && (
                        <LongShortBalance
                            data={AnalysisData && AnalysisData.long_short_comp}
                        />
                    )}
                    {profileActive === 2 && mainTabination === 2 && (
                        <ResultbyDays data={AnalysisData && AnalysisData?.day_wise_data} />
                    )}
                    {profileActive === 3 && mainTabination === 2 && (
                        <LongShortComparison data={AnalysisData} />
                    )}
                    {/* {profileActive === 4 && mainTabination === 2 && (
                <TradingdaysAnalysis
                  data={AnalysisData && AnalysisData.trading_days_analysis}
                  days={
                    AnalysisData &&
                    AnalysisData.final_evaluation.minimum_10_training_days
                  }
                />
              )} */}
                    {/* {profileActive === 5 && mainTabination === 2 && (
                <ResultsByPosition
                  data={AnalysisData && AnalysisData.results_by_lots}
                />
              )} */}
                    {profileActive === 6 && mainTabination === 2 && (
                        <ResultsByTrade
                            data={AnalysisData && AnalysisData.result_by_trade_duration?.data}
                        />
                    )}
                    {profileActive === 7 && mainTabination === 2 && (
                        <ResultsByOpenHour
                            data={AnalysisData && AnalysisData.result_by_open_hour?.data}
                        />
                    )}
                </div>
            </div>
            {/* )} */}
        </div>
    );
};
export default AccountAnalysisShare;
